//export const SERVICE_BASE_URI = 'http://localhost:8081/EE/rest/react/';
 //export const SERVICE_BASE_URI = "http://10.2.110.206:8080/IAOT/rest/react/";
//export const SERVICE_BASE_URI = "https://iww.iaopstool.bureauveritas.com/IAOT/rest/react/";
//export const SERVICE_BASE_URI = "https://approvals.bureauveritas.com/IAOT-API/rest/react/";
export const SERVICE_BASE_URI = "https://approvals.bureauveritas.com/IAOT-API/react/";
// export const SERVICE_BASE_URI: "http://iww.tpd.hk.bureauveritas.com/IAOT/rest/ee/";

export const Severity = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success'
};

export const API_CONSTANTS = {
  APPR_PROD_MAIN_SUB_JOINED_LIST: 'APPR_PROD_MAIN_SUB_JOINED_LIST',
  APPR_COUNTRY_LIST: 'APPR_COUNTRY_LIST',
  APPR_TECH_TYPE_LIST: 'APPR_TECH_TYPE_LIST',
  APPR_SERVICE_TYPE_LIST: 'APPR_SERVICE_TYPE_LIST',
  APPR_MP_PROD_TYPE_LIST: 'APPR_MP_PROD_TYPE_LIST',
  APPR_MP_REGION_COUNTRY_LIST: 'APPR_MP_REGION_COUNTRY_LIST',
  APPR_REG_LIB_STATUS_LIST: 'APPR_REG_LIB_STATUS_LIST',
  VENDOR_CURRENCY_LIST: 'VENDOR_CURRENCY_LIST',
  VENDOR_SAMPLE_LIST: 'VENDOR_SAMPLE_LIST',
};

export const EE_LU_WO_STATUS = {
  Prepare: 4001,
  In_Progress: 4002,
  Complete: 4003,
  Stop: 4004,
  Hold: 4005,
  Cancel: 4006,
  Late: 4007,
  Drafting: 4008,
  Document_Preparation: 4010,
  Document_Preparation_Sample_Collection: 4020,
  Testing_in_Progress: 4030,
  Submission_Complete: 4040,
  Under_Review: 4050,
  Certificate_Received: 4060
};

export const ProjectDetailsExcelTemplate = {
  Project_Info: 'Project Information',
  Project_No: 'Project No.:',
  Project_Status: 'Project Status:',
  Brand_Name: 'Brand/OEM:',
  Model_Name: 'Product Model:',
  Service_Name: 'Service Name',
  Status: 'Status',
  Country: 'Country/Territory',
  Start_Date: 'Start Date',
  Estimate_completion_Date: 'Due Date',
  Completion_Date: 'Completion Date',
  Remarks: 'Remarks',
  Service_Info: 'Service Information'
};

export const UserActivity = {
  CP__Login: 99998,
  VP__Login: 99996,
  CP__Dashboard_Visited: 13100,
  CP__Dashboard_Sub_Proj_Search: 13101, //new
  CP__Dashboard_CM_Decision_Search: 13102, //new
  CP__Dashboard_CM_Expiration_Search: 13103, //new
  CP__Dashboard_All_Proj_Search: 13104, //new
  CP__Dashboard_By_Proj_Search: 13105, //new

  CP__ProjectMgmt_Visited: 13200,
  CP__ProjectMgmt_Search: 13201,
  CP__ProjectMgmt_Report_Download: 13202, //new
  CP__ProjectDetails_Gantt_Chart_Visited: 13204, //new
  CP__ProjectDetails_Visited: 13500,
  CP__ProjectDetails_Report_Download: 13700,

  CP__CertMgmt_Visited: 13300,
  CP__CertMgmt_Search: 13301,
  CP__CertMgmt_Renewal_Update: 13302, 
  CP__Cert_Detail_Visited: 13303, //new 
  CP__Cert_Report_Download: 13304, //new 
  CP__Cert_Create_New_Visited: 13305, //new 
  CP__Cert_Create_New_Created: 13306, //new 
  CP__Cert_Bulk_Upload_Visited: 13307, //new 
  CP__Cert_Bulk_Upload_Created: 13308, //new 
  CP__Cert_Renewal_Created: 13309, //new 
  CP__Cert_Upload_Updated: 13310, //new /
  CP__Cert_Upload_Update_Visited: 13311, //new 

  CP__Services_Visited: 13400,
  CP__Services_Search: 13401,
  CP__Requirement_Summ_Detail_Visited: 13402, //new

  CP__RegLibDashboard_Visited: 17000, //new
  CP__RegLibDetails_QA_Visited: 17001, //new
  CP__RegLibDashboard_Search: 17002, //new
  CP__RegLibDashboard_Filter_Search: 17003, //new
  CP__RegLibDashboard_Detail_Visited: 17004, //new
  CP__RegLibDashboard_Apply_Fav: 17005, //new
  CP__RegLibDashboard_Share: 17006, //new
  CP__RegLibDashboard_Save_Query: 17007, //new
  CP__RegLibDashboard_Send_Proposal: 17008, //new
  CP__RegLibDashboard_Save_Fav: 17009, //new
  CP__RegLibDashboard_Raise_Further_Query: 17010, //new
  CP__RegLibDashboard_Query_Detail_Visited: 17011, //new

  //Vendor Portal
  VP__Sub_Project_Visited: 19000, //new
  VP__Sub_Project_Search: 19001, //new
  VP__Sub_Project_Detail_Visited: 19002, //new
  VP__Sub_Project_Detail_Save: 19003, //new
  VP__Sub_Project_Detail_Doc_Accept: 19004, //new
  VP__Sub_Project_Detail_Doc_Reject: 19005 //new
};


export const getLstYearsDB = (() => {
  const startYear = 2016;
  const currentYear = new Date().getFullYear();
  const years = {};

  for (let year = startYear; year <= currentYear; year++) {
    years[year] = `${year}`;
  }

  years[0] = 'All';

  return years;
})();


export const getMonthlyFreq = {
  QUARTERLY: 1,
  MONTHLY: 2,
  WEEKLY: 3
}

export const prjStatus = [
  {
    intId: 30002,
    strLongDesc: 'In Progress'
  },
  {
    intId: 30003,
    strLongDesc: 'On Hold'
  },
  {
    intId: 30004,
    strLongDesc: 'Complete'
  },
  {
    intId: 30005,
    strLongDesc: 'Cancelled'
  },
  {
    intId: 30007,
    strLongDesc: 'Stopped'
  }
];

export const certStatus = [
  {
    intId: 2,
    strLongDesc: 'Valid'
  },
  {
    intId: 3,
    strLongDesc: 'Expired'
  },
  {
    intId: 1,
    strLongDesc: 'Indefinite'
  },
  {
    intId: 4,
    strLongDesc: 'Cancelled'
  }
];
export const certRenewalStatus = [
  { intId: 6010, strLongDesc: 'Renewal Undecided' },
  { intId: 6020, strLongDesc: 'Renewal Not Needed' },
  { intId: 6030, strLongDesc: 'Renewal Requested' },
  { intId: 6040, strLongDesc: 'Renewal In Progress' },
  { intId: 6050, strLongDesc: 'Renewal Complete' },
  { intId: 6055, strLongDesc: 'Cancellation Requested' },
  { intId: 6060, strLongDesc: 'Renewal Cancelled' }
];

export const projectType = [
  {
      "intId": 1,
      "strLongDesc": "New",
      
  },
  {
      "intId": 2,
      "strLongDesc": "Renewal",
  }
];

export const vendorSubPrjStatus = [
  { intId: 4010, strLongDesc: "Document Preparation" },
  { intId: 4020, strLongDesc: "Document Preparation & Sample Collection" },
  { intId: 4030, strLongDesc: "Testing in Progress" },
  { intId: 4040, strLongDesc: "Submission Complete" },
  { intId: 4050, strLongDesc: "Application under review by Authority" },
  { intId: 4060, strLongDesc: "Certificate Received" },
  { intId: 4003, strLongDesc: "Complete" },
  { intId: 4005, strLongDesc: "On Hold" },
  { intId: 4004, strLongDesc: "Stopped" },
  { intId: 4006, strLongDesc: "Cancelled" },
];

